/**
 * @generated SignedSource<<2c0e5eea76f0174dcdc1ac2bc955e2ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DuplicateModelResultStatus = "ERROR" | "SUCCESS" | "WARNING";
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type productListDuplicateMutation$variables = {
  id: string;
  targets: ReadonlyArray<ModelDuplicateTargetInput>;
};
export type productListDuplicateMutation$data = {
  readonly duplicateModel: {
    readonly productIDs: ReadonlyArray<number> | null;
    readonly resultMessage: string | null;
    readonly status: DuplicateModelResultStatus;
  };
};
export type productListDuplicateMutation = {
  response: productListDuplicateMutation$data;
  variables: productListDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targets"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "targets",
        "variableName": "targets"
      }
    ],
    "concreteType": "DuplicateModelResult",
    "kind": "LinkedField",
    "name": "duplicateModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productIDs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productListDuplicateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productListDuplicateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "499eee3054de31d4d82ac310cd98d2c0",
    "id": null,
    "metadata": {},
    "name": "productListDuplicateMutation",
    "operationKind": "mutation",
    "text": "mutation productListDuplicateMutation(\n  $id: ID!\n  $targets: [ModelDuplicateTargetInput!]!\n) {\n  duplicateModel(id: $id, targets: $targets) {\n    productIDs\n    resultMessage\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "069e716472d25244b72744709ed90536";

export default node;
